import axios from '@axios'

const PREFIX = '/empresas'

export default {
  /**
   * Obtém o histórico de alterações de uma empresa.
   * @param {number} empresaId - ID da empresa.
   * @returns {Promise} - Promise com os dados do histórico.
   */
  obterHistorico(empresaId) {
    return axios.get(`${PREFIX}/${empresaId}/historico-alteracoes`)
  },
}
